module.exports = __webpack_public_path__ + "static/media/iphone-14-pro-frame.111ad3d2.png";